import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import CustomRouter from './routes';

import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { primaryTheme } from './utils/theme';
import { SidebarProvider } from './contexts';

function App() {
  const { t } = useTranslation('common');

  return (
    <div className="App">
      <SidebarProvider>
        <ThemeProvider theme={primaryTheme}>
          <Suspense fallback={<div className="app__suspense-fallback">{t('loading')}</div>}>
            <BrowserRouter>
              <CustomRouter />
              <ToastContainer autoClose={6000} hideProgressBar={true} />
            </BrowserRouter>
          </Suspense>
        </ThemeProvider>
      </SidebarProvider>
    </div>
  );
}

export default App;
